import { AppRoute, AppRouteId } from './route-data';
import { CustomerSearchPage } from './src/customer-search-page/components/customer-search.page';
import { FeatureFlagPage } from './src/feature-flag/feature-flag.page';
import { ProfilePage } from './src/profile-page/components/profile.page';

export const routes: AppRoute[] = [
  {
    path: '',
    component: CustomerSearchPage,
    data: {
      routeId: AppRouteId.CUSTOMER_SEARCH,
    },
  },
  {
    path: 'customer/:accountNumber',
    component: ProfilePage,
    data: {
      routeId: AppRouteId.PROFILE,
      parentRouteId: AppRouteId.CUSTOMER_SEARCH,
    },
  },
  {
    path: 'feature-flag',
    component: FeatureFlagPage,
    data: {
      routeId: AppRouteId.FEATURE_FLAG,
    },
  },
  {
    path: '**',
    redirectTo: '',
    data: { routeId: AppRouteId.CUSTOMER_SEARCH },
  },
];
